/**
 * Admin copy for W6-RIDE-PIN (D399, ADR-0064): the support cancel reason for a ride whose start PIN locked after five
 * wrong attempts (`ops_start_pin_locked` — nobody at fault, no fee; there is no PIN reset). Kept in its own file;
 * `messages.ts` spreads it into the catalog and asserts no id collides. Same four base languages.
 */
type RidePinEntry = Readonly<{ pt: string; en: string; es: string; it: string }>;

export const RIDE_PIN_DICT: Readonly<Record<string, RidePinEntry>> = {
  'ride.cancel.reason.ops_start_pin_locked': {
    pt: 'PIN de embarque bloqueado',
    en: 'Start PIN locked',
    es: 'PIN de embarque bloqueado',
    it: 'PIN di partenza bloccato',
  },
};
